import { PARAGRAPH_TYPE } from './constant.js';
import { paragraphElementToHtml } from './element-to-html.js';
import { paragraphHtmlToElement } from './html-to-element.js';
import { paragraphPlugin } from './plugin.js';
import { paragraphRenderElement } from './render-element.js';
import { paragraphSerializer } from './serializer.js';

const ParagraphModule = {
  type: PARAGRAPH_TYPE,
  renderElement: paragraphRenderElement,
  elementToHtml: paragraphElementToHtml,
  htmlToElement: paragraphHtmlToElement,
  plugin: paragraphPlugin,
  serializer: paragraphSerializer
};

export { ParagraphModule };
//# sourceMappingURL=module.js.map
